document.addEventListener("DOMContentLoaded", function () { 
  
  // hero banner start
  document.querySelectorAll('.hero-banner-logo-container a').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent default anchor behavior
      const targetId = this.getAttribute('href').substring(1); // Get the section ID
      
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth' // Smooth scrolling
        });
      }
    });
  });
  // hero banner end  
  
  // custom multicolumn start
  document.querySelectorAll('.custom-multicolumn a').forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });
  // custom multicolumn end
  
  if (window.innerWidth <= 768) {
    // Loop through every .swiper container on the page
    document.querySelectorAll(".supplierSwiper").forEach(function (el) {
      // Create unique swiper instance for each container
      const swiperInstance = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        speed: 1000,
        pagination: {
          el: el.querySelector(".swiper-pagination"), // use its own pagination
          clickable: true,
        },
      });
      
      // Add click event for pause/play toggle
      el.addEventListener("click", () => {
        const activeSlide = el.querySelector(".swiper-slide-active");
        if (activeSlide && activeSlide.classList.contains('paused-slidee')) {
          activeSlide.classList.remove('paused-slidee')
        } else {
          activeSlide.classList.add('paused-slidee')
        }  
      });
    });
  }
  
  if (window.innerWidth <= 768) {
    const swiper = new Swiper(".feature-grid", {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    
    swiper.on("slideChangeTransitionEnd", function () {
      swiper.pagination.update();
    });
    
    const featureGridContainer = document.querySelector(".feature-grid");
    
    featureGridContainer?.addEventListener("click", () => {
      const activeSlide = featureGridContainer.querySelector(".swiper-slide-active");
      if (activeSlide && activeSlide.classList.contains('paused-slide')) {
        activeSlide.classList.remove('paused-slide')
      } else {
        activeSlide.classList.add('paused-slide')
      }
    });
  }
  
  // 3-col slider end
  
  
  // lightbox gallery homepage
  const lightbox = GLightbox({
    selector: '.glightbox'
  });
  
  const lightboxVideo = GLightbox({
    selector: '.glightbox-video'
  });
  // lightbox gallery homepage end


  const bestsellerSwiper = new Swiper(".bestseller-swiper", {
    slidesPerView: 4,
    spaceBetween: 5,
    loop: true,
    pagination: {
      el: ".bestseller-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".bestseller-button-next",
      prevEl: ".bestseller-button-prev",
    },
    breakpoints: {
      320: { slidesPerView: 2 },
      480: { slidesPerView: 2 },
      768: { 
        slidesPerView: 3,
        spaceBetween: 10
      },
      1025: {
        slidesPerView: 4,
        spaceBetween: 10
      },
    },
  });
  
}); // DOMContentLoaded